import type {
	MenuItemLinks,
	NavBarItem,
	NavBarLinkItem,
	NavBarMenuItem,
	NavCta,
} from '@ds-mgnl/marketing';

export const topNavData: NavBarItem[] = [
	{
		type: 'link',
		link: {
			label: 'Services',
			path: '/services',
			value: '/services',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
	{
		type: 'link',
		link: {
			label: 'Portfolio',
			path: '/projects',
			value: '/projects',
			openInNewTab: false,
		},
	} as NavBarLinkItem,
	{
		type: 'submenu',
		label: 'Insights',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Expertise',
								path: '/resources/blogs',
								value: '/resources/blogs',
								openInNewTab: false,
							},
							{
								label: 'News board',
								path: '/news',
								value: '/news',
								openInNewTab: false,
							},
							{
								label: 'Case studies',
								path: '/resources/case-studies',
								value: '/resources/case-studies',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
	{
		type: 'submenu',
		label: 'About',
		items: [
			{
				type: 'links',
				linkGroups: [
					{
						label: '',
						links: [
							{
								label: 'Our story',
								path: '/about/our-story',
								value: '/about/our-story',
								openInNewTab: false,
							},
							{
								label: 'Our approach',
								path: '/about/our-approach',
								value: '/about/our-approach',
								openInNewTab: false,
							},
							{
								label: 'Our people',
								path: '/people',
								value: '/people',
								openInNewTab: false,
							},
						],
					},
				],
			} as MenuItemLinks,
		],
	} as NavBarMenuItem,
];

export const ctaLinks: NavCta[] = [
	{
		path: '/contact',
		label: 'Contact',
		value: '/contact',
		openInNewTab: false,
	},
];
